module.exports = __webpack_public_path__ + "img/lvyou-1.df7ae9cb.jpg";